document.addEventListener("latte:init", init);

function init() {
	$(window).trigger("load.zf.sticky"); //reinit sticky post AJAX content update
	var pjax = require('./lib/pjax');

	$('.navTab').click(function (e) {
		pjax.loadUrl($(this).attr('data-url')); //will refresh the content container
	});


	buttonOn = false;
	var buttonPrimary = $(".billboard .js-primary").first(); //only grab the primary button in the first billboard
	var menu = $(".menu.horizontal").first();

	if (menu.offset() && buttonPrimary.offset()) {
		var buttonPrimaryHeight = buttonPrimary.offset() ? buttonPrimary.offset().top : 0;

		if (buttonPrimaryHeight < menu.offset().top) {
			// Check if Billboard Button exist and Check if Billboard Button is above menu

			var viewportWidth = $(window).width();
			if (viewportWidth < 1024) {
				//Add Mobile Button & Phone Number
				$('<a class="btn btn--white nav-btn" href="tel:' + content.phoneNum + ' " >' + content.phone + "</a>").appendTo(".gray-bar .js-btns-mobile"); // clone button into nav
				$(buttonPrimary).clone().removeClass('btn--white').addClass('btn--primary').appendTo(".gray-bar .js-btns-mobile"); // clone button into nav
			} else {
				// Add Desktop Buttons
				$(buttonPrimary).clone().removeClass('btn--white').addClass('btn--primary').appendTo(".gray-bar .js-btns-desktop"); // clone button into nav
				$(".gray-bar .row").css("max-width", "none");
			}

			$(".gray-bar .btn").removeClass("btn--large");

			$(window).scroll(function () {
				scrollTop = $(window).scrollTop();
				// if button scrolls above window top
				if (buttonPrimaryHeight + 60 < scrollTop && buttonOn === false) {
					$(".gray-bar .btn").show(600);
					buttonOn = true; //Tag to stop button being cloned multiple times
				} else if (buttonPrimaryHeight + 60 > scrollTop && buttonOn === true) {
					$(".gray-bar .btn").hide(600);
					$(".gray-bar .row").css("max-width", "default"); //remove row width
					buttonOn = false;
				}
			});
		}
	}
}



//////////////////
// WEBPACK FOOTER
// ./public/js/navigation.js
// module id = 82
// module chunks = 0